export const globalStyleTokens = {
  telephoneLinkUnderline: 'none',
  focusVisible: false,
  strongFontFamily: 'inherit',
} as const;

export const inputTokens = {
  borderDefault: 'brandOne100',
  borderValid: 'brandOne100',
  borderSize: '2px',
} as const;

export const pageTokens = {
  borderRadius: 'medium',
  buyWithConfidenceBackgroundColor: 'brandOne100',
  includeSummaryWord: true,
  includeAddAPet: false,
  useHeroHeading: false,
  useAnnualWord: false,
  coverTypesToCheck: ['any'],
  paymentPageWhichDisclaimerPosition: 'outside',
} as const;
